import { render, staticRenderFns } from "./WorkplacePayrollValueModal.vue?vue&type=template&id=6f076a9c&"
import script from "./WorkplacePayrollValueModal.vue?vue&type=script&lang=js&"
export * from "./WorkplacePayrollValueModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports